import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import userService from '../../../services/authority/userService';
import platformRoleService from '../platformRoles/platformRoleService';
import SaaSUserForm from './SaaSUserForm';

const SaaSUserEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const params = useParams();
  const [errors, setErrors] = useState<string[]>([]);
  const [platformRoles, setPlatformRoles] = useState<any[]>([]);
  const [entity, setEntity] = useState<any>({
    id: 0,
    fullName: '',
    email: '',
    platformRoleIds: [],
  });

  useEffect(() => {
    platformRoleService.list().then((response) => {
      if (!response.hasError) {
        setPlatformRoles(
          (response.records ?? []).map((x: any) => ({
            id: x.id ?? x.Id,
            name: x.name ?? x.Name,
          }))
        );
      }
    });
  }, []);

  useEffect(() => {
    if (!params.id) return;
    userService.get(params.id).then((response: any) => {
      if (response.hasError) {
        setErrors(response.errorMessages ?? []);
        enqueueSnackbar((response.errorMessages ?? []).join(','), {
          variant: 'error',
        });
        return;
      }
      const result = response.result ?? {};
      setEntity({
        id: result.id ?? result.Id,
        fullName: result.fullName ?? result.FullName ?? '',
        email: result.email ?? result.Email ?? '',
        platformRoleIds:
          result.platformRoleIds ?? result.PlatformRoleIds ?? [],
      });
    });
  }, [params.id]);

  const onSubmit = (payload: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    userService
      .update(payload)
      .then((response: any) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
          return;
        }
        enqueueSnackbar('Sikeres mentés!', { variant: 'success' });
        navigate('/authority/saas-users');
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <SaaSUserForm
      entity={entity}
      platformRoles={platformRoles}
      errors={errors}
      onSubmit={onSubmit}
      handleCancel={() => navigate('/authority/saas-users')}
    />
  );
};

export default SaaSUserEdit;
